import { noop } from 'lodash'
import React from 'react'
import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from '../../../../node_modules/@mui/material'
import DeleteButton from '../../../common/iconButtons/DeleteButton'
import EditButton from '../../../common/iconButtons/EditButton'
import { Mutation } from '../../../react-apollo/Components'
import RestrictedView from '../../auth/RestrictedView'
import { i18n } from '../../index'
import { deleteReminderMutation, getStationReminders } from './RemindersQueries'
import css from './reminders.css'

export type RemindersTableItemData = {
  id: string
  name: string
  time: string
  weekdays: string[]
}
interface RemindersTableProps {
  stationId: string
  reminders: RemindersTableItemData[]
  onEdit: (reminder: RemindersTableItemData) => void
}
export const RemindersTable = ({ stationId, reminders, onEdit }: RemindersTableProps) => {
  const onDelete = (onMutate, reminderId) => {
    onMutate({ variables: { id: reminderId } })
  }

  return (
    <Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={css.tableHeading}>{i18n.t('admin.reminders.reminder')}</TableCell>
            <TableCell className={css.tableHeading} padding='checkbox'>
              {i18n.t('admin.reminders.time')}
            </TableCell>
            <TableCell className={css.tableHeading} padding='checkbox'>
              {i18n.t('admin.reminders.weekdays')}
            </TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {reminders.map((reminder) => (
            <TableRow key={reminder.id}>
              <TableCell className={css.tableCell}>{reminder.name}</TableCell>
              <TableCell className={css.tableCell}>{reminder.time}</TableCell>
              <TableCell className={css.tableCell}>
                {reminder.weekdays.length === 7 && i18n.t('admin.reminders.all')}
                {reminder.weekdays.length < 7 &&
                  reminder.weekdays.map((weekday) => i18n.t(`admin.reminders.short.${weekday}`)).join(', ')}
              </TableCell>
              <TableCell className={css.tableCell} align='right'>
                <RestrictedView requiredPermission='manage_ownStation'>
                  <EditButton className={css.actionButton} onClick={() => (reminder.id ? onEdit(reminder) : noop)} />
                  <Mutation
                    mutation={deleteReminderMutation}
                    refetchQueries={[
                      {
                        query: getStationReminders,
                        variables: { stationId },
                      },
                    ]}
                  >
                    {(onMutate) => (
                      <DeleteButton onClick={() => (reminder.id ? onDelete(onMutate, reminder.id) : noop)} />
                    )}
                  </Mutation>
                </RestrictedView>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  )
}
